import { SourceControlProvider } from "@modules/graphql/types"

export function useSupportedSourceControlProviders(): SourceControlProvider[] {
  const availableSourceControlProviders = [
    SourceControlProvider.Github,
    SourceControlProvider.Gitlab,
    SourceControlProvider.Bitbucket,
    SourceControlProvider.GithubEnterprise,
    SourceControlProvider.GitlabSelfManaged,
  ]

  return availableSourceControlProviders
}
